<template>
	<div>
		<v-alert
			v-if="errormsg.length !== 0"
			type="error"
			border="top"
			colored-border
		>
			{{ errormsg }}
		</v-alert>
		<div v-if="errormsg.length === 0 && loading">
			<v-progress-linear
				indeterminate
				color="#EAEAEA"
				background-color="#DADADA"
				rounded
				width="100px"
				height="15px"
				style="margin: 5px"
			></v-progress-linear>

			<v-progress-linear
				indeterminate
				color="#EAEAEA"
				background-color="#DADADA"
				rounded
				width="100px"
				height="15px"
				style="margin: 5px"
			></v-progress-linear>
		</div>
		<div class="timesheet-summary" v-if="errormsg.length === 0 && !loading">
			<div class="timesheet-item" :class="$vuetify.breakpoint.smAndDown ? 'timesheet-item-xs':'timesheet-item-lg'">
				<div class="timesheet-item-text">
					<div>
						<div class="data-title data-title-green">Billable</div>
						<div :class="`mt-1 data-text data-text-black ${$vuetify.breakpoint.xs ? 'font-size-xs': 'font-size-default'}`">{{ formatDuration(stage_before_timesheet_billable) }}</div>
					</div>
					<div class="mt-10">
						<div class="data-title data-title-grey">Non-billable</div>
						<div :class="`mt-1 data-text data-text-black ${$vuetify.breakpoint.xs ? 'font-size-xs': 'font-size-default'}`">{{ formatDuration(stage_before_timesheet_nonbillable) }}</div>
					</div>
				</div>
				<DoughnutChart class="doughnut-chart" v-if="errormsg.length === 0 && !loading" :data="chartdata_thisweek" :options="options"/>
				<div class="timesheet-item-text">
					<div>
						<div class="data-title data-title-red">Not logged</div>
						<div :class="`mt-1 data-text data-text-red ${$vuetify.breakpoint.smAndDown ? 'font-size-xs': 'font-size-default'}`">{{ formatDuration(nolog_this_week) }}</div>
					</div>
					<div class="mt-10">
						<div class="data-title data-title-grey">Rest of the week</div>
						<div :class="`mt-1 data-text data-text-grey ${$vuetify.breakpoint.xs ? 'font-size-xs': 'font-size-default'}`">{{ formatDuration(rest_this_week) }}</div>
					</div>
				</div>
			</div>
			<div class="item-space"></div>
			<div class="timesheet-item" :class="$vuetify.breakpoint.smAndDown ? 'timesheet-item-xs':'timesheet-item-lg'">
				<div class="timesheet-item-text">
					<div>
						<div class="data-title data-title-green">Billable</div>
						<div :class="`mt-1 data-text data-text-black ${$vuetify.breakpoint.xs ? 'font-size-xs': 'font-size-default'}`">{{ formatDuration(last_week_timesheet_billable) }}</div>
					</div>
					<div class="mt-10">
						<div class="data-title data-title-grey">Non-billable</div>
						<div :class="`mt-1 data-text data-text-black ${$vuetify.breakpoint.xs ? 'font-size-xs': 'font-size-default'}`">{{ formatDuration(last_week_timesheet_nonbillable) }}</div>
					</div>
				</div>
				<DoughnutChart class="doughnut-chart" v-if="errormsg.length === 0 && !loading" :data="chartdata_lastweek" :options="options"/>
				<div class="timesheet-item-text">
					<div>
						<div class="data-title data-title-red">Not logged</div>
						<div :class="`mt-1 data-text data-text-red ${$vuetify.breakpoint.smAndDown ? 'font-size-xs': 'font-size-default'}`">{{ formatDuration(nolog_last_week) }}</div>
					</div>
					<div v-if="isLogTime && nolog_last_week !== 0" class="mt-10 log-button px-3" @click="onLogTimesheet()">
						<span v-if="$vuetify.breakpoint.smAndDown">Log time</span>
						<span v-if="!$vuetify.breakpoint.smAndDown">Log time now</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment';
import DoughnutChart from "@/components/charts/doughnut_chart";
import config from '@/config.js';

const TYPE_CAPACITY = {
	last_week: 0,
	today_before: 1,
	today_after: 2,
	current_week: 3
};

/** from sunday to satuday */
const LAST_WEEK_SUN = moment().day(-7).format("YYYY-MM-DD"); 
const LAST_WEEK_SAT = moment().day(-1).format("YYYY-MM-DD");

const WEEK_START = moment().day(0).format("YYYY-MM-DD");
const WEEK_END = moment().day(6).format("YYYY-MM-DD");

const TODAY = moment().format("YYYY-MM-DD");

export default {
	name: 'TimesheetSummary',
	components: {
		DoughnutChart,
	},
	props: {
		isLogTime: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			errormsg: '',
			last_week_capacity: null,
			last_week_timesheet_nonbillable: null,
			last_week_timesheet_billable: null,
			current_week_capacity: null,
			stage_before_capacity: null,
			stage_before_timesheet_nonbillable: null,
			stage_before_timesheet_billable: null,
			loading_timesheet: true,
			loading_capacity: true,
		}
	},
	computed: {
		...mapState(['user']),
		loading() {
			if (!this.loading_capacity && !this.loading_timesheet) {
				return false;
			}
			return true;
		},
		chartdata_thisweek() {
			const billable = this.stage_before_timesheet_billable;
			const non_billable = this.stage_before_timesheet_nonbillable;
			const notlogged = this.stage_before_capacity - this.stage_before_timesheet_billable - this.stage_before_timesheet_nonbillable;

			/** rest_week is the grey color part, don't show the lable on it */
			let rest_week = 0
			/** if not logged is negative, do not show it */
			if (notlogged <= 0) {
				rest_week = this.current_week_capacity - this.stage_before_timesheet_billable - this.stage_before_timesheet_nonbillable;
			} else {
				rest_week = this.current_week_capacity - this.stage_before_timesheet_billable - this.stage_before_timesheet_nonbillable - notlogged;
			}

			let labels = [];
			let data_values = [];

			if (rest_week <= 0) {
				labels = non_billable > 0 ? [[`billable  ${this.formatDuration(billable)}`, `non-billable  ${this.formatDuration(non_billable)}`]] : [`billable  ${this.formatDuration(billable)}`];
				data_values = [(billable + non_billable)];
			} else {
				if (non_billable > 0) {
					labels.push([`billable  ${this.formatDuration(billable)}`, `non-billable  ${this.formatDuration(non_billable)}`]);
				} else {
					labels.push(`billable  ${this.formatDuration(billable)}`);
				}

				if (notlogged > 0) {
					labels.push(`not logged  ${this.formatDuration(notlogged)}`);
				}

				/** for rest_week part */
				labels.push(null);

				data_values = [(billable + non_billable), (notlogged > 0 ? notlogged : 0), rest_week];
			}

			const data = {};
			data['text'] = 'This Week';
			data['datasets'] = [{
				labels: labels,
				data: data_values,
				backgroundColor: [
					config.doughnut_chart_colors.billable,
					config.doughnut_chart_colors.notLogged,
					config.doughnut_chart_colors.upcoming
				],
				borderColor: [
					config.doughnut_chart_colors.billable,
					config.doughnut_chart_colors.notLogged,
					config.doughnut_chart_colors.upcoming,
				],
				borderWidth: 0.1
			}]

			return data;
		},
		chartdata_lastweek() {
			const billable = this.last_week_timesheet_billable;
			const non_billable = this.last_week_timesheet_nonbillable;
			const notlogged = this.last_week_capacity - this.last_week_timesheet_nonbillable - this.last_week_timesheet_billable;

			let labels = [];
			let data_values = [];
			
			/** not display if 'not logged' is negative or 0 */
			if (notlogged <= 0) {
				labels = non_billable > 0 ? [[`billable  ${this.formatDuration(billable)}`, `non-billable  ${this.formatDuration(non_billable)}`]] : [`billable  ${this.formatDuration(billable)}`];
				data_values = [(billable + non_billable)];
			} else {
				labels = non_billable > 0 ? [[`billable  ${this.formatDuration(billable)}`, `non-billable  ${this.formatDuration(non_billable)}`], `not logged  ${this.formatDuration(notlogged)}`] : [`billable  ${this.formatDuration(billable)}`, `not logged  ${this.formatDuration(notlogged)}`];
				data_values = [(billable + non_billable), notlogged];
			}

			const data = {};
			data['text'] = 'Last Week',
			data['datasets'] = [{
				labels: labels,
				data: data_values,
				backgroundColor: [
					config.doughnut_chart_colors.billable,
					config.doughnut_chart_colors.notLogged,
				],
				borderColor: [
					config.doughnut_chart_colors.billable,
					config.doughnut_chart_colors.notLogged,
				],
				borderWidth: 0.1
			}]

			return data;
		},
		options() {
			const options = {
				responsive : true,
				cutoutPercentage: 65,
				labels: {
					display: true,
				},
				tooltips: {
					enabled: true,
					filter: function(tooltipItem) {
						if (tooltipItem.index === 2) {
							return false; 
						}
						return true;
					},
					callbacks: {
						label: ((tooltipItems, data) => {
							const datasetIndex = tooltipItems.datasetIndex;
							const index = tooltipItems.index;
							const title = data.datasets[datasetIndex].labels[index];

							return title;
						})
					}
				}
			}
			return options;
		},
		rest_this_week() {
			/** total capacity - capacity for days that have past this week (including today) */
			return this.current_week_capacity - this.stage_before_capacity;
		},
		nolog_this_week() {
			/** capacity for days that have past this week (including today) - billable - non billable */
			return this.stage_before_capacity - this.stage_before_timesheet_billable - this.stage_before_timesheet_nonbillable;
		},
		nolog_last_week() {
			/** total capacity of last week - billable - non-billable */
			return this.last_week_capacity - this.last_week_timesheet_nonbillable - this.last_week_timesheet_billable;
		}		
	},
	watch: {
		user() {
			if (this.user !== null) {
				this.load();
			}
		},
	},
	created() {
		this.load();
	},
	methods: {
		load() {
			if (this.user == null) {
				// not yet available, still loading...
				console.log("User not yet available...");
				return;
			} else if (this.user.addressbook == null) {
				this.errormsg = "Your user account is not linked to an employee record...";
				return;				
			}

			// last week
			this._load_capacity(LAST_WEEK_SUN, LAST_WEEK_SAT, TYPE_CAPACITY.last_week);
			this._load_timesheet(LAST_WEEK_SUN, LAST_WEEK_SAT, true);

			// current week
			this._load_capacity(WEEK_START, WEEK_END, TYPE_CAPACITY.current_week);
			this._load_timesheet(WEEK_START, TODAY, false);

			// capacity for days that have past this week(including today)
			this._load_capacity(WEEK_START, TODAY, TYPE_CAPACITY.today_before);
		},
		onLogTimesheet() {
			this.$router.push({ name: "Timesheets"});
		},
		_load_timesheet(start_time, end_time, is_lastweek) {
			const params = [];
			params.push("employees=" + this.user.addressbook.id);
			params.push('start_date='+ start_time);
			params.push('end_date='+ end_time);

			// build our url, we have to add url escaping here!
			let url = "/api/timesheets";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			this.loading_timesheet = true;
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status == "OK") {
						this.loading_timesheet = false;

						const timesheets = data;
						let total_timesheet_duration_nonbillable = 0;
						let total_timesheet_duration_billable = 0;

						if (timesheets.length !== 0) {
							timesheets.forEach(timesheet => {
								if (timesheet.is_admin_time) {
									total_timesheet_duration_nonbillable += timesheet.duration;
								} else {
									total_timesheet_duration_billable += timesheet.duration;
								}
							});
						}
						
						if (is_lastweek) {
							this.last_week_timesheet_nonbillable = total_timesheet_duration_nonbillable;
							this.last_week_timesheet_billable = total_timesheet_duration_billable;
						} else {
							this.stage_before_timesheet_nonbillable = total_timesheet_duration_nonbillable;
							this.stage_before_timesheet_billable = total_timesheet_duration_billable;
						}
					} else {
						this.errormsg = reason;
					}					
				})
				.catch(e => {
					this.errormsg = e.message;
				})
				.finally(() => {
				})
		},
		_load_capacity(start_time, end_time, type) {
			const params = [];
			params.push('from_date='+ start_time);
			params.push('to_date='+ end_time);

			let url = `/api/addressbook/${this.user.addressbook.id}/capacity`;
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}
			this.loading_capacity = true;
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status == "OK") {
						this.loading_capacity = false;	

						if (type === TYPE_CAPACITY.last_week) {
							this.last_week_capacity = data.capacity;

						} else if(type === TYPE_CAPACITY.today_before) {
							this.stage_before_capacity = data.capacity;

						} else if(type === TYPE_CAPACITY.current_week) {
							this.current_week_capacity = data.capacity;
						}
					} else {
						this.errormsg = reason;
					}
				})
				.catch(e => {
					this.errormsg = e.message;
				})
				.finally(() => {
				});	
		},
		formatDuration(minutes) {
			let fmt = '';

			if (minutes !== null) {
				if (minutes === 0) {
					fmt = '0m';
				}

				if (minutes > 0) {
					const hours = Math.floor(minutes / 60.0);
					const mins = minutes - (hours * 60.0);
			
					if (hours > 0) {
						fmt += hours + 'h';
						if (mins > 0) {
							fmt += ' ';
						}
					}

					if (mins > 0) {
						fmt += mins + 'm';
					}
				}

				if (minutes < 0) {
					fmt = '0m';
				}
			}
			
			return fmt;
		}
	}
}
</script>
<style lang="scss" scoped>
.doughnut-chart {
  width: 40%;
  height: 40%;
  margin-bottom: 4px;
}
.timesheet-summary {
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
}
.timesheet-item {
  display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
  
}
.timesheet-item-lg {
	width: 65%;
}
.timesheet-item-xs {
	width: 90%;
}
.timesheet-item-text {
  display: flex;
	flex-flow: column nowrap;
	align-items: flex-start;
	width: 25%;
	flex: 1 1 1;
}
.log-button {
	background: #F45252;
	border-radius: 4px;
	color: #FFFFFF;

  font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 32px;
	&:hover {
		cursor: pointer;
	}
}
.data-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
}
.data-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  line-height: 18px;
}
.data-title-green {
	color: #81CC00;
}
.data-title-purple {
	color: rgba(96, 90, 246, 0.5);
}
.data-title-red {
  color: #F45252;
}
.data-title-grey {
  color: rgba(25, 42, 62, 0.5);
}
.data-text-green {
	color: #6BA900;
}
.data-text-purple {
	color: #605AF6;
}
.data-text-red {
  color: #EE0202;
}
.data-text-grey {
  color: rgba(25, 42, 62, 0.5);
}
.data-text-black {
  color: #000000;
}
.font-size-xs {
	font-size: 12px;
}
.font-size-default {
	font-size: 16px;
}
.item-space {
	height: 32px;
}
</style>